module.exports = __webpack_public_path__ + "img/discount_howto2.e62680b9.jpg";